/**
 * Calculates widget position data relative to viewport and document.
 */
export const getWidgetPositionData = (
  target?: ShadowRoot | HTMLElement | null,
) => {
  try {
    let containerElement: HTMLElement | null = null
    if (target) {
      if (target instanceof ShadowRoot) {
        containerElement = target.host as HTMLElement
      } else if (target instanceof HTMLElement) {
        containerElement = target
      }
    }

    if (!containerElement) {
      const firstChild = target?.firstElementChild
      if (firstChild instanceof HTMLElement) {
        containerElement = firstChild
      }
    }

    if (!containerElement) {
      return null
    }

    const rect = containerElement.getBoundingClientRect()
    const windowInnerHeight = window.innerHeight
    const scrollY = window.scrollY || window.pageYOffset
    const viewportTop = rect.top
    const viewportBottom = rect.bottom
    const documentTop = viewportTop + scrollY
    const componentWidth = rect.width
    const componentHeight = rect.height
    const score =
      windowInnerHeight > 0
        ? (documentTop + componentHeight) / windowInnerHeight
        : null

    const isAboveTheFold = viewportTop < windowInnerHeight && viewportBottom > 0

    return {
      window_inner_height: windowInnerHeight,
      viewport_top: Math.round(viewportTop),
      viewport_bottom: Math.round(viewportBottom),
      document_top: Math.round(documentTop),
      component_width: Math.round(componentWidth),
      component_height: Math.round(componentHeight),
      score: score !== null ? Math.round(score * 100) / 100 : null,
      is_above_the_fold: isAboveTheFold,
    }
  } catch (error) {
    return null
  }
}
